import React from 'react';
import ReactDOM from 'react-dom/client';
import { Workspace } from './editor/app/Workspace';
import { initInstallCapture } from './editor/io/pwa-install';
import './editor/styles.css';

declare const __MAIPO_BUILD_ID__: string;

// Capture the install prompt before React mounts (the event can fire early).
initInstallCapture();

if (new URLSearchParams(window.location.search).get('headless') === '1') {
  void import('./editor/tooling/headless').then((module) => module.install());
}

if (new URLSearchParams(window.location.search).get('public-headless') === '1') {
  void import('./editor/public-format/browser').then((module) => module.installPublicFormatBrowserApi());
}

// Addons are opt-in and never bundled into core: this resolves to nothing at
// all unless the deployment serves /addons/manifest.json or ?addons= is passed.
void import('./editor/addons/loader').then((module) => module.loadAddons()).catch(() => {});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Workspace />
  </React.StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  const recoveryKey = 'maipo-asset-recovery-v2';
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent<unknown>) => {
    const message = event.data;
    if (!message || typeof message !== 'object' || !('type' in message) || message.type !== 'MAIPO_ASSET_RECOVERY_REQUIRED') return;
    const previous = Number(window.sessionStorage.getItem(recoveryKey) ?? 0);
    if (Date.now() - previous <= 5_000) return;
    window.sessionStorage.setItem(recoveryKey, String(Date.now()));
    if (window.localStorage.getItem('maipo-has-dirty-sessions') === 'true') {
      window.dispatchEvent(new CustomEvent('maipo-asset-recovery-required'));
      return;
    }
    window.location.reload();
  });
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(__MAIPO_BUILD_ID__)}`, { updateViaCache: 'none' });
  });
}
